﻿(function ($) {
    var intervalId = 0;
    "use strict";
    var FpCarousel = function (container, element, options) {        
        this.el = $(element);
        this.width = this.el.width();
        this.container = $(container);
        this.options = options;
        this.pos = this.container.position();        

        this.init();

        var moveToSlide = $.proxy(this.moveToSlide, this);

        this.el.on('swipeRight', function (e) {
            e.stopImmediatePropagation();
            var slide = $(options.buttons + ".current").data("slide");
            if (slide > 1) {
                $(".media-content-message").removeClass("show-message");
                clearInterval(intervalId);
                moveToSlide(slide - 2);
            }
        });

        this.el.on('swipeLeft', function (e) {
            e.stopImmediatePropagation();
            var slide = $(options.buttons + ".current").data("slide");
            if (slide < options.numberOfElements) {
                $(".media-content-message").removeClass("show-message");
                clearInterval(intervalId);
                moveToSlide(slide--);
            }
        });

        $(this.options.buttons).on("click", function (e) {
            var slide = $(this).data("slide");            
            $(".media-content-message").removeClass("show-message");
            clearInterval(intervalId);
            moveToSlide(slide - 1);
        });
        
        $(window).on('resize', $.proxy(this.resize, this));
    };

    FpCarousel.prototype = {        
        init: function () {
            this.resize();            
            this.setTimer();
        },
        resize:function () {
            $(".media-content-message").eq(0).addClass("show-message");
            this.width = this.el.width();
            this.pos = this.container.position();

            if (!this.isInPostition() && this.pos.left != 0) {
                $(this.options.buttons + ".current").removeClass("current").parent().children().first().addClass("current");
                this.move(0, function () { });
            }
        },
        moveToSlide: function (slide) {      
                $(this.options.buttons + ".current").removeClass("current");
                $(this.options.buttons).eq(slide).addClass("current");                

                this.move(-(this.width * slide), function () {
                    $(".media-content-message").eq(slide).addClass("show-message");
                });            
        },
        move: function (pos, callback) {
            /*if (Modernizr.csstransforms3d) {
                this.container.css({
                    transform: 'translate3d(' + pos + 'px' + ',0,0)'
                });
            }
            else {*/
                this.container.css({
                    left: pos + "px"
                });
            //}
            callback();
        },
        isInPostition: function () {
            for (var i = 0; i < this.options.numberOfElements; i++) {
                if (this.pos.left === (-this.width * i))
                    return true;
            }
            return false;
        },
        setTimer: function() {
            clearInterval(intervalId);
            var triggerNext = $.proxy(this.triggerNext, this);
            intervalId = setInterval(function () {
                triggerNext();
            }, 7000);            
        },
        triggerNext: function () {
            var slide = $(this.options.buttons + ".current").data("slide");
            $(".media-content-message").removeClass("show-message");
            if (slide === this.options.numberOfElements)
                this.moveToSlide(0);
            else
                this.moveToSlide(slide);
        }
    };

    $.fn.fpcarousel = function (container, option) {

        return this.each(function () {
            var $this = $(this),
				data = $this.data('fpcarousel'),
				options = $.extend({}, $.fn.fpcarousel.defaults, typeof option == 'object' && option);
            if (!data) $this.data('fpcarousel', (data = new FpCarousel(this, container, options)));
            if (typeof option == 'string') data[option]();
        });
    };

    $.fn.fpcarousel.defaults = {
        'numberOfElements': 1,
        'buttons': ".buttons a"
    };

    $.fn.fpcarousel.Constructor = FpCarousel;

}(window.jQuery));